/** Shop nomenclature ids of the two selectable invoice methods (VP / receipt). */
export interface InvoiceTypeIds {
  want: number
  none: number
}

export interface OrderNomsResponse {
  invoice?: { want?: number | null, none?: number | null }
}

export function invoiceIdsFromNoms(data: OrderNomsResponse | null | undefined): InvoiceTypeIds | null {
  const want = data?.invoice?.want
  const none = data?.invoice?.none
  return typeof want === 'number' && typeof none === 'number' ? { want, none } : null
}

/**
 * invoiceTypeId of a guest order (or of an account without a client) from OrderNoms.
 * null means the id is unknown and the order must not be sent.
 */
export function orderInvoiceTypeId(wantInvoice: boolean, nomsIds: InvoiceTypeIds | null): number | null {
  if (!nomsIds) return null
  return wantInvoice ? nomsIds.want : nomsIds.none
}
